/**
 * Debounce given async function so it does not run until delay milliseconds
 * after the last call.
 * @param func - the function to debounce
 * @param delay - the time to wait (in milliseconds)
 */
export function debounceAsync(func, delay) {
    let timeout;
    return (...args) => {
        // Create a new promise that will be returned by the debounced function
        return new Promise((resolve, reject) => {
            const later = () => {
                clearTimeout(timeout);
                func(...args)
                    .then(resolve)
                    .catch(reject);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, delay);
        });
    };
}
/** Get the env the hostname, defaulting to `'prod'` if unmatched */
export const envFromHostname = (hostname = window.location.hostname) => {
    if (hostname === 'localhost.annalect.com' || hostname === 'localhost')
        return undefined;
    const match = hostname.match(/^(dev|qa|stg|).*\.annalect\.com$/);
    if (!match)
        return undefined;
    return (match[1] || 'prod');
};
//# sourceMappingURL=utils.js.map